module.exports = __webpack_public_path__ + "static/media/Etang_IlotD_synthese_7.4d8b1dd5.webp";